import DOMPurify from 'dompurify';

// SVG presentation elements — no scripting, animation, or foreign-object embedding.
const ALLOWED_TAGS = ['svg', 'g', 'path', 'circle', 'ellipse', 'rect', 'line', 'polyline', 'polygon', 'defs', 'use', 'symbol', 'clipPath', 'mask', 'linearGradient', 'radialGradient', 'stop', 'text', 'tspan', 'title', 'desc'];

// SVG presentation attributes — no event handlers, no style, no external URIs.
const ALLOWED_ATTR = ['viewBox', 'xmlns', 'fill', 'fill-opacity', 'fill-rule', 'stroke', 'stroke-width', 'stroke-linecap', 'stroke-linejoin', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-opacity', 'd', 'cx', 'cy', 'r', 'rx', 'ry', 'x', 'x1', 'x2', 'y', 'y1', 'y2', 'width', 'height', 'points', 'transform', 'opacity', 'id', 'clip-rule', 'clip-path', 'mask', 'offset', 'stop-color', 'stop-opacity', 'gradientUnits', 'gradientTransform', 'preserveAspectRatio'];
export function sanitizeSvgMarkup(raw) {
  if (typeof document === 'undefined') {
    // SSR: DOMPurify requires a browser DOM, so only pattern-level checks run here.
    // The full allowlist pass runs at hydration.
    if (/javascript:/i.test(raw) || /<script/i.test(raw)) return null;
    return raw;
  }
  const sanitized = DOMPurify.sanitize(raw, {
    ALLOWED_TAGS,
    ALLOWED_ATTR
  });
  if (!sanitized || !sanitized.trimStart().toLowerCase().startsWith('<svg')) {
    return null;
  }
  return sanitized;
}